// extracted by mini-css-extract-plugin
export default {"form":"vb2NL4cs4Pb8o3pZoAkE"};